import React from "react";
// react plugin that creates an input with badges
import {globals,hiring_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalHiring } from '../../redux/modalSlice'; 
import { updateHiring, addHiring } from '../../redux/hiringSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const HiringFormDialog = () => {
  const {hiringModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("hiringModal -> ",hiringModal);
    console.log("hiringModal.activeObject -> ",hiringModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalHiring())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              {hiringModal.activeObject &&
              <h1>{hiringModal.activeObject.data_blob.data_tier.hiring_title}</h1>}
              {hiringModal.activeObject===null &&
              <h1>{"<Nouvelle offre d'emploi>"}</h1>}
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {hiring_form}
                company_guid = {globals.datasync.platform_company_guid}
                table_guid= {globals.datasync.pf_hirings_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Offre d'emploi enregistrée"})); console.log("HiringFormDialog::saved_data ->",saved_data);dispatch(addHiring(saved_data)); dispatch(closeModalHiring());}}
                //Let us update the articl
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Hiring modifié"})); console.log("HiringFormDialog::updated_data ->",updated_data); dispatch(updateHiring(updated_data)); dispatch(closeModalHiring());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur de sauvegarde de l'offre d'emploi"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalHiring())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {hiringModal.activeObject}
                data_blob = {hiringModal.activeObject?hiringModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {hiringModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default HiringFormDialog;
